<template>
  <div class="flex justify-between items-center mt-3">
    <p class="date">{{fromDate}}</p>
    <LikeButton :participation="participation" />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import LikeButton from '@/components/LikeButton.vue'
import DateService from '@/services/DateService'

export default {
  name: 'InfoFooterCard',
  props: {
    participation: {
      type: Object,
      required: true
    }
  },
  components: {
    LikeButton
  },
  computed: {
    ...mapState(['translations', 'codeLang']),
    fromDate () {
      return DateService.getFromDate(this.participation.cms_createdAt, this.codeLang)
    }
  }
}
</script>

<style scoped>
.date {
  --tw-text-opacity: 1;
  color: rgba(116, 116, 116, var(--tw-text-opacity));
}
</style>
